import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, NavParams, Platform } from '@ionic/angular';
import { StorageService } from '../../services/storage.service';
import { APIService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ObserverService } from '../../services/observer.service';
import { OrganisationService } from './../../services/organisation.service';
import { OrganisationPickerPage } from '../../modals/organisation-picker/organisation-picker.page';


@Component({
    selector: 'app-person-filter',
    templateUrl: './person-filter.page.html',
    styleUrls: ['./person-filter.page.scss'],
})

export class PersonFilterPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    filter_params = {};
    tags = [];
    email_lists = [];
    organisation = null;
    organisation_title = null;
    hide_organisation_selector = false
    online = true;

    tag_select_options: any = { header: 'Tag' };
    email_list_select_options: any = { header: 'Email list' };
    has_credit_limit_select_options: any = { header: 'Has credit limit' };
    has_amount_owing_select_options: any = { header: 'Has amount owing' };
    has_exceeded_credit_limit_select_options: any = { header: 'Has exceeded credit limit' };

    // modal flags
    organisation_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public navParams: NavParams,
        public loadingController: LoadingController,
        private observerService: ObserverService,
        private organisationService: OrganisationService,
        private router: Router,
        private authService: AuthService,
        private apiService: APIService,
    ) { }

    ngOnInit() {

        // NOTE: order list has been called from organisation view
        if(this.navParams.get('hide_organisation_selector')) {
            this.hide_organisation_selector = this.navParams.get('hide_organisation_selector');
        }

        if(this.navParams.get('tag_id')) {
            this.filter_params['tag_id'] = this.navParams.get('tag_id');
        }

        if(this.navParams.get('email_list_id')) {
            this.filter_params['email_list_id'] = this.navParams.get('email_list_id');
        }

        if(this.navParams.get('has_credit_limit') != undefined) {
            this.filter_params['has_credit_limit'] = this.navParams.get('has_credit_limit');
        }

        if(this.navParams.get('has_amount_owing') != undefined) {
            this.filter_params['has_amount_owing'] = this.navParams.get('has_amount_owing');
        }

        if(this.navParams.get('has_exceeded_credit_limit') != undefined) {
            this.filter_params['has_exceeded_credit_limit'] = this.navParams.get('has_exceeded_credit_limit');
        }

        if(this.navParams.get('organisation_id')) {
            this.filter_params['organisation_id'] = this.navParams.get('organisation_id');
            this.organisationService.getOrganisation(this.filter_params['organisation_id'],{}).then((organisation) => {
                if(organisation) {
                    this.organisation_title = organisation["title"];
                }
            })
            .catch(() => { });
        }

        this.loadData().then(() => { }).catch(() => { });

        this.observerService.subscribe('network_status_changed|order_filter_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Problem", "Offline", "You must be online to filter people, please check your network connection and try again.");
                }
            }
        });

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading email lists").then(() => {
                this.loadEmailLists().then(() => {
                    this.loading_spinner.message = "Loading tags";
                    this.loadPersonTags().then(() => {
                        this.loading_spinner.dismiss();
                        resolve();
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadEmailLists() {
        return new Promise<void>((resolve, reject) => {
            this.email_lists = [];
            this.authService.isLoggedIn().then(() => {
                this.apiService.getEmailLists().then((email_lists) => {
                    if(email_lists) {
                        this.email_lists = email_lists;
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert('Problem', 'Unknown error', 'Unfortunately something went wrong when trying to retrieve a list of email lists.');
                    } 
                    else if(error.status == 403) {
                        this.presentAlert('Problem', 'Insufficient permissions', "You don't have permission to view a list of email lists.");
                    } 
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert('Problem', 'Unavailable', "Unfortunately we're unable to retrieve a list of email lists at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadPersonTags() {
        return new Promise<void>((resolve, reject) => {
            this.tags = [];
            this.authService.isLoggedIn().then(() => {
                this.apiService.getPersonTags().then((tags) => {
                    if(tags) {
                        this.tags = tags;
                    }
                    resolve();
                }).catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert('Problem', 'Unknown error', 'Unfortunately something went wrong when trying to get a list of a persons tags');
                    } 
                    else if(error.status == 403) {
                        this.presentAlert('Problem', 'Insufficient permissions', 'You don\'t have permission to view a persons tags.');
                    } 
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert('Problem', 'Unavailable', 'Unfortunately we\'re unable to retrieve a list of a persons tags at this time.');
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    filter() {
        this.modalController.dismiss(this.filter_params);
    }

    close() {
        this.modalController.dismiss();
    }

    clearTag() {
        delete this.filter_params['tag_id'];
    }

    clearEmailList() {
        delete this.filter_params['email_list_id'];
    }

    clearHasCreditLimit() {
        delete this.filter_params['has_credit_limit'];
    }

    clearHasAmountOwing() {
        delete this.filter_params['has_amount_owing'];
    }

    clearHasExceededCreditLimit() {
        delete this.filter_params['has_exceeded_credit_limit'];
    }

    clearFilters() {
        this.presentSpinner("Clearing filters").then(() => {

            if(this.filter_params['tag_id']) {
                delete this.filter_params["tag_id"];
            }
            if(this.filter_params['email_list_id']) {
                delete this.filter_params["email_list_id"];
            }
            if('has_credit_limit' in this.filter_params) {
                delete this.filter_params["has_credit_limit"];
            }
            if('has_amount_owing' in this.filter_params) {
                delete this.filter_params["has_amount_owing"];
            }
            if('has_exceeded_credit_limit' in this.filter_params) {
                delete this.filter_params["has_exceeded_credit_limit"];
            }

            // NOTE: people list has been called from organisation view, need to prevent organisation_id being cleared
            if(!this.hide_organisation_selector && this.filter_params['organisation_id']) {
                delete this.filter_params["organisation_id"];
                this.organisation_title = null;
            }

            this.spinner.dismiss();

        });
    }

    async presentOrganisationPickerModal() {
        if(!this.organisation_picker_modal_open) {
            this.organisation_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: OrganisationPickerPage,
                componentProps: {
                    organisation_id: (this.filter_params['organisation_id'] ? this.filter_params['organisation_id'] : null),
                    hide_add_organisation_button: true
                }
            });
            modal.onDidDismiss().then((data) => {
                this.organisation_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "organisation_deleted") {
                        delete this.filter_params["organisation_id"];
                        this.organisation_title = null;
                    }
                    else {
                        this.filter_params['organisation_id'] = data.data['organisation_id'];
                        this.organisation_title = data.data['organisation_title'];
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
